export enum StorageKeys {
  GrabbedUserData = '@grabbedUserData',
  UserSeenNotificationPopup = '@userSeenNotificationPopup',
  NavigationMenuOpenState = '@navigationMenuOpenState',
}
